import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from 'features/onboarding'
import { z } from 'zod/v4'

const onboardingSearchSchema = z.object({})

export type OnboardingSearch = z.infer<typeof onboardingSearchSchema>

export const Route = createFileRoute('/_authenticated/onboarding')({
  component: OnboardingPage,
  validateSearch: onboardingSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Add Workspace'),
      },
    ],
  }),
})
